import { ApexOptions } from "apexcharts";
import { title } from "process";
import { FC, useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import "utils/number-utils";

interface PartnerDailyChartProps {
    title: string,
    series: any,
    categories: string[]
};

const DashboardBarchart: FC<PartnerDailyChartProps> = ({ title, series, categories }) => {
    const [chartOption, setChartOption] = useState<ApexOptions>();

    useEffect(() => {
        var option: ApexOptions = {
            chart: {
                type: 'bar',
                height: 350
            },
            title: {
                text: title
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },
            plotOptions: {
                bar: {
                    horizontal: false
                }
            },
            yaxis: {
                title: {
                    style: {
                        fontFamily: 'Inter'
                    }
                }
            },
            xaxis: {
                categories: categories,
                labels: {
                    formatter: function (value) {
                        return value;
                    }
                }
            },
            tooltip: {
                shared: true,
                intersect: false,
                y: {
                    formatter: function (y) {
                        return String.toFormatSeparator(y, 0, 0);
                    }
                }
            },
            colors: ['#2c7a7b', '#4fd1c5']
        };

        setChartOption(option);
    }, []);

    return (
        <>
            {chartOption && <ReactApexChart options={chartOption} height={'350px'} type={'bar'} series={series} />}
        </>
    );
};

export default DashboardBarchart;